// extracted by mini-css-extract-plugin
export default {"listAccent":"styles_listAccent__81zvY","paymentCheckList":"styles_paymentCheckList__m-j7R"};